
define('ldsh!modules/editor/templates/edit_element_popup_tab', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a data-i18n="editor.propertyGroups.' +
((__t = ( iname )) == null ? '' : __t) +
'" data-bypass class="js-tab-switch" href="#">' +
((__t = ( name )) == null ? '' : __t) +
'</a>\n';

}
return __p
};});

